import {useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {FiEdit} from "react-icons/fi";
import {Button, Drawer} from "@mui/material";
import LandingAutoComplete from "../../LandingAutoComplete";
import * as React from "react";

export default function StaffVetsLandingInsert({idx, row, data, setData, setLoading, openForm , isOpenNew, setIsOpenNew}) {

    const [open, setOpen] = useState(false);

    async function storeAddress(r) {

        const tkn = await FunctionsData.getCSRFToken();
        let requestOptionsVoucher = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.sTkn,
                'X-CSRF-Token': tkn.csrf
            },
            body: JSON.stringify({
                dpid: r.DPID,
                address_json: JSON.stringify(r),
                verified: 1,
                formatted_address: r.address,
                city: r.TOWN_CITY_MAILTOWN,
                suburb: r.SUBURB_NAME,
                postcode: r.POSTCODE,
                street: r.STREET_NUMBER + ' ' + r.STREET_NAME
            })
        };

        await fetch(FunctionsData.getApiUrl("/api/vet/") + row.id, requestOptionsVoucher)
            .then(response => response.json())
            .then((res) => {
                row.dpid = r.DPID;
                row.address_json = JSON.stringify(r);
                row.verified = 1;
                row.formatted_address = r.address;
                row.city = r.TOWN_CITY_MAILTOWN;
                row.suburb = r.SUBURB_NAME;
                row.postcode = r.POSTCODE;
                row.street = r.STREET_NUMBER + ' ' + r.STREET_NAME;
                setOpen(false);

                let d = data;
                for (let x in d) {
                    if (x === idx) {
                        d[x] = row;
                    }
                }

                setData(d);
                setLoading(true);

            })
    }

    const ShowButtons = ({ isOpenNew, setIsOpenNew, row }) => {
        if (parseInt(row.verified) > 0 && isOpenNew === false) {
            return (
                <div>
                    {row.formatted_address}{" "}
                    <a href="Staff" onClick={(e) => {
                        e.preventDefault();
                        setIsOpenNew(true);
                    }}>
                        <FiEdit/>
                    </a>
                    <div style={{paddingTop: 0}}>
                        <div style={{marginTop: 0}}>
                            <Button disabled variant={"contained"}>
                                Address is verified
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div>
                {row.formatted_address}
                <div style={{paddingTop: 0}}>
                    <Button
                        size="small"
                        onClick={() => setIsOpenNew(true)}
                        variant={"contained"}
                        sx={{background: 'red'}}
                    >
                        Verify / add address
                    </Button>
                </div>
            </div>
        );
    };

    const ShowComplete = ({ row, isOpenNew, setIsOpenNew }) => {
        if (open === false) return null;
        return (
            <div>
                <Drawer
                    open={isOpenNew}
                    anchor={"right"}
                    onClose={() => setIsOpenNew(false)}
                >
                    <div style={{width: 550, padding: 20}}>
                        <div style={{paddingTop: 10}}>
                            <Button variant={"contained"} sx={{marginBottom: 2}}
                                    onClick={() => setIsOpenNew(false)}>Cancel</Button>
                            <h3 style={{marginBottom: 20}}>Verify the address</h3>
                            <LandingAutoComplete close={1}
                                                 setGooglePlace={storeAddress}
                                                 row={row}
                            />
                        </div>
                    </div>
                </Drawer>
            </div>
        )
    }

    return (
        <div>
            <ShowButtons isOpenNew={open} setIsOpenNew={setOpen} row={row}/>
            <ShowComplete row={row} isOpenNew={open} setIsOpenNew={setOpen}/>
        </div>
    )
}
